import { i18n } from "./init";
// Building a formatter is costly (notably on Hermes); lists format per row.
const formatters = new Map();
/** Dates follow the UI locale. Numbers do not; prices stay `1,234,567` everywhere. */
export const formatDate = (date, options) => {
    const locale = i18n.language || "en-US";
    const key = `${locale}|${JSON.stringify(options ?? {})}`;
    let formatter = formatters.get(key);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(locale, options);
        formatters.set(key, formatter);
    }
    return formatter.format(new Date(date));
};
//# sourceMappingURL=formatDate.js.map